import { render, staticRenderFns } from "./EditionsYearEdition.vue?vue&type=template&id=fbc207bc&"
import script from "./EditionsYearEdition.vue?vue&type=script&lang=js&"
export * from "./EditionsYearEdition.vue?vue&type=script&lang=js&"
import style0 from "./EditionsYearEdition.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports